import {isPlainObject, mapValues} from "lodash"

export function mapValuesDeep(v, callback) {
  return isPlainObject(v)
      ? mapValues(v, v => {
        return mapValuesDeep(v, callback)
      })
      : callback(v)
}

export async function mapValuesDeepAsync(v, asyncCallback) {
  if (v instanceof Array) {
    return await Promise.all(v.map(i => mapValuesDeepAsync(i, asyncCallback)));
  }
  return isPlainObject(v)
      ? mapValuesAsync(v, v => mapValuesDeepAsync(v, asyncCallback))
      : await asyncCallback(v)
}

export async function mapValuesAsync(obj, asyncCallback) {
  const keys = Object.keys(obj);
  const promises = keys.map(async k => ({key: k, value: await asyncCallback(obj[k])}));
  const newObj = {};
  (await Promise.all(promises)).forEach(v => newObj[v.key] = v.value);
  return newObj;
}